import Lenis from "lenis";
import {mapActions, mapState} from "vuex";

export default {
    data() {
        return {
            startX: 0,
            currentX: 0,
            totalSlides: 0,
            timer: null,
            time: 0
        }
    },
    computed: {
        ...mapState('scrollModule', ['optionsHorizontalScroll', 'lenis', 'isCentered']),
        ...mapState(['isBlockScroll', '$isScrollParent']),
        event() {
            return this.optionsHorizontalScroll?.event
        },
        inHorizontalZone() {
            return this.optionsHorizontalScroll?.inHorizontalZone
        },
        wrapper() {
            return this.optionsHorizontalScroll?.wrapper
        },
        currentSlide() {
            return this.optionsHorizontalScroll?.currentSlide
        },
        isTouch() {
            return this.optionsHorizontalScroll?.isTouch
        },
        isNext() {
            return this.optionsHorizontalScroll?.isNext
        },
        isScrolling() {
            return this.optionsHorizontalScroll?.isScrolling
        },

        atFirst() {
            return this.currentSlide === 0;
        },
        atLast() {
            return this.currentSlide === this.totalSlides - 1;
        },
    },
    watch: {
        isBlockScroll() {
            if(this.isBlockScroll) {
                this.lenis?.stop();
            } else {
                this.lenis?.start();
            }
        }
    },
    unmounted() {
        // removeEventListener('wheel', this.onWheel, { passive: false })
        // removeEventListener('touchstart', this.handleTouchStart)
        // removeEventListener('touchmove', this.handleTouchMove)
        // removeEventListener('touchend', this.handleTouchEnd)
    },
    methods: {
        ...mapActions(['BLOCK_SCROLL_GLOBAL']),
        ...mapActions('scrollModule', ['OPTIONS_HORIZONTAL_SCROLL', 'SET_LENIS', 'SET_CENTERED']),

        watcherHorizontalBlock() {
            if (this.isScrolling) return
            clearTimeout(this.timer)
            this.OPTIONS_HORIZONTAL_SCROLL({
                isScrolling: true,
                isTouch: this.isTouch
            })
            let allowUp, allowDown = false;
            let direction = 1;
            console.log(this.isTouch)
            if(this.isTouch) {
                direction = this.isNext ? 1 : -1
                allowUp = this.atFirst && !this.isNext
                allowDown = this.atLast && this.isNext
            } else {
                const delta = this.event.deltaY
                direction = delta > 0 ? 1 : -1
                allowUp = this.atFirst && direction < 0
                allowDown = this.atLast && direction > 0
            }

            if (!(allowUp || allowDown)) {
                this.event.preventDefault()
                this.event.stopPropagation()
                const next = this.currentSlide + direction
                if (next >= 0 && next < this.totalSlides) {
                    this.OPTIONS_HORIZONTAL_SCROLL({
                        currentSlide: next,
                        isTouch: this.isTouch
                    })
                }
            }
            this.timer = setTimeout(() => {
                this.OPTIONS_HORIZONTAL_SCROLL({
                    isScrolling: false,
                    isTouch: false
                })
            }, 1000)
        },

        initHorizontalBlock() {
            const wrapper = this.$refs.horizontalWrapper
            this.OPTIONS_HORIZONTAL_SCROLL({
                isTouch: this.isTouch,
                wrapper
            })
        },
        initLenis() {
            let lenis = new Lenis({
                el: this.$refs.scrollContainer, // кастомный контейнер
                smooth: true,
                direction: 'vertical',
                gestureDirection: 'vertical',
                lerp: 0.04,
                syncTouch: true
            })
            this.SET_LENIS(lenis)

            const raf = (time) => {
                this.lenis.raf(time)
                requestAnimationFrame(raf)
            }
            requestAnimationFrame(raf)
            this.lenis.on('scroll', (el) => {
                this.checkHeaderFixed();
                // this.checkHorizontalScroll(el);
            })
            // window.addEventListener('wheel', this.onWheel, { passive: false })
        },
        handleTouchStart(e) {
            this.startX = e.touches[0].clientX
            this.time = performance.now()
        },
        handleTouchMove(e) {
            this.currentX = e.touches[0].clientX
        },
        handleTouchEnd(e) {
                const dx = this.currentX - this.startX
                if (dx > 30) this.onTouch(false, e)
                else if (dx < -30) this.onTouch(true, e)
        },

        onTouch(isNext, e) {
            this.OPTIONS_HORIZONTAL_SCROLL({
                event: e,
                isTouch: true,
                isNext
            })
            // const allowUp = !isNext && this.atFirst
            // const allowDown = isNext && this.atLast
            // this.startLenisAfterStopScrolling(allowUp, allowDown)
            // this.OPTIONS_HORIZONTAL_SCROLL({
            //     isTouch: false
            // })
        },

        onWheel(e) {
            this.OPTIONS_HORIZONTAL_SCROLL({
                event: e
            })
            const delta = e.deltaY
            const dir = delta > 0 ? 1 : -1
            const allowUp = dir < 0 && this.atFirst
            const allowDown = dir > 0 && this.atLast
            this.startLenisAfterStopScrolling(allowUp, allowDown)
        },

        startLenisAfterStopScrolling(allowUp, allowDown) {
            if ((allowUp || allowDown) && !this.isScrolling && !this.isBlockScroll) {
                this.lenis.start()
                this.SET_CENTERED(false)
            }
        },

        checkHorizontalScroll(element) {
            if(!this.$isScrollParent) {
                let scroll = element.scroll;
                // Считаем начало и конец горизонтального блока
                const wrapperTop = this.wrapper?.offsetTop
                const wrapperHeight = this.wrapper?.offsetHeight
                let scrollStart = wrapperTop
                // let num = window.innerWidth < 769
                //     ? 30
                //     : 20
                // let scrollEnd = wrapperTop + (wrapperHeight / num);
                let scrollEnd = wrapperTop + wrapperHeight;


                // const inView =
                //     scroll + window.innerHeight / 2 >= wrapperTop ||
                //     scroll + window.innerHeight / 2 < scrollEnd


                let inHorizontalZone = scroll >= scrollStart && scroll <= scrollEnd;
                // if (inView && inHorizontalZone && !this.isCentered && !this.isScrolling) {
                //     this.SET_CENTERED(true)
                //     this.scrollToBlockStatic('about', true, true)
                //     this.lenis.stop()
                // }
                this.OPTIONS_HORIZONTAL_SCROLL({
                    isTouch: this.isTouch,
                    inHorizontalZone
                })
            }

        },
    }
}